export const comics = [
  {
    id: 'secret-romance',
    title: '秘密恋爱手册',
    author: '金智秀',
    slug: 'secret-romance',
    category: 'love',
    rating: 9.4,
    coverSeq: 'comic-01',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第128话',
    updateDate: '2026-07-02',
    description: '公司里最受欢迎的男神组长，竟然主动提出要和我进行"秘密恋爱练习"？这一切源于我醉酒后的无心之言。每周三的地下会议室，心跳加速的秘密特训，究竟他是在练习，还是早已动了真心？一段办公室里的秘密恋情，就此展开。',
    tags: ['办公室恋情', '甜宠', '年上', '秘密关系'],
    chapters: 128,
    totalViews: 3250000,
    isHot: true,
  },
  {
    id: 'dungeon-warrior',
    title: '地下城勇士',
    author: '朴志勋',
    slug: 'dungeon-warrior',
    category: 'fantasy',
    rating: 9.6,
    coverSeq: 'comic-02',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第215话',
    updateDate: '2026-07-03',
    description: '一场意外让我穿越到了充满魔物的地下城世界。在这里，我觉醒了独一无二的"无限成长"技能。从最低级猎人到最强勇士，与各路伙伴一起，踏上征服深渊的征途。隐藏在深渊最深处的真相，究竟是什么？',
    tags: ['穿越', '升级流', '冒险', '热血'],
    chapters: 215,
    totalViews: 5860000,
    isHot: true,
  },
  {
    id: 'campus-revenge',
    title: '校园复仇记',
    author: '李敏浩',
    slug: 'campus-revenge',
    category: 'action',
    rating: 9.2,
    coverSeq: 'comic-03',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第95话',
    updateDate: '2026-07-01',
    description: '曾经被全校霸凌的弱者，经过三年的秘密特训后归来。这一次，他不再是任人欺凌的软柿子。面对昔日霸凌者的恐惧眼神，他缓缓说出："游戏，才刚刚开始。"一部关于复仇、成长与救赎的校园动作故事。',
    tags: ['校园', '复仇', '成长', '格斗'],
    chapters: 95,
    totalViews: 2180000,
    isHot: true,
  },
  {
    id: 'perfect-neighbor',
    title: '完美邻居',
    author: '崔秀英',
    slug: 'perfect-neighbor',
    category: 'love',
    rating: 9.3,
    coverSeq: 'comic-04',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第82话',
    updateDate: '2026-07-02',
    description: '搬进新公寓第一天，就遇到了传说中"全楼最帅"的邻居。他温柔体贴、厨艺一流，还总是在我最需要的时候出现。然而，这个看似完美的男人，却隐藏着一个让人意想不到的秘密身份。',
    tags: ['邻家', '甜宠', '悬疑', '都市'],
    chapters: 82,
    totalViews: 1490000,
    isHot: false,
  },
  {
    id: 'ghost-detective',
    title: '幽灵侦探',
    author: '郑宇成',
    slug: 'ghost-detective',
    category: 'suspense',
    rating: 9.5,
    coverSeq: 'comic-05',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第167话',
    updateDate: '2026-07-03',
    description: '一场车祸后，我获得了看见鬼魂的能力。从此，没有破不了的悬案。从街头失踪案到豪门离奇死亡事件，每一桩案件背后都隐藏着不为人知的秘密。而我身边的这位鬼魂搭档，似乎也有未了的心愿。',
    tags: ['推理', '超自然', '单元剧', '都市'],
    chapters: 167,
    totalViews: 4720000,
    isHot: true,
  },
  {
    id: 'laughing-daily',
    title: '爆笑日常',
    author: '姜虎东',
    slug: 'laughing-daily',
    category: 'comedy',
    rating: 9.1,
    coverSeq: 'comic-06',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第203话',
    updateDate: '2026-07-01',
    description: '一个普通上班族的爆笑日常生活。从挤地铁的奇妙冒险，到办公室的奇葩同事，再到家里那只成精的猫——每个平凡的日子都充满了意想不到的笑料。看完保证你笑到肚子疼！',
    tags: ['搞笑', '日常', '四格', '轻松'],
    chapters: 203,
    totalViews: 3640000,
    isHot: false,
  },
  {
    id: 'crimson-moon',
    title: '赤月之下',
    author: '韩素希',
    slug: 'crimson-moon',
    category: 'drama',
    rating: 9.7,
    coverSeq: 'comic-07',
    coverWidth: 400,
    coverHeight: 560,
    status: '完结',
    updatedChapter: '第180话（完结）',
    updateDate: '2026-06-15',
    description: '朝鲜王朝末年，一个没落贵族之女与身份低微的画师之间的禁忌之恋。在动荡的时代洪流中，两人用画笔记录下彼此的模样，也为后世留下了一段跨越阶级的绝美爱情。荣获多项漫画大奖的史诗级作品。',
    tags: ['历史', '爱情', '悲剧', '古风'],
    chapters: 180,
    totalViews: 8250000,
    isHot: true,
  },
  {
    id: 'nightmare-academy',
    title: '噩梦学园',
    author: '金泰亨',
    slug: 'nightmare-academy',
    category: 'horror',
    rating: 9.0,
    coverSeq: 'comic-08',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第76话',
    updateDate: '2026-06-30',
    description: '转学到一所偏僻的寄宿学校后，我发现这里的校规异常诡异。午夜后禁止离开宿舍、每周五的"特别课程"、以及那些莫名消失的学生们。当真相一层层被揭开，我才意识到，这所学校也许根本不应该存在。',
    tags: ['恐怖', '校园', '悬疑', '惊悚'],
    chapters: 76,
    totalViews: 1930000,
    isHot: false,
  },
  {
    id: 'healing-cafe',
    title: '疗愈咖啡馆',
    author: '朴宝英',
    slug: 'healing-cafe',
    category: 'daily',
    rating: 9.3,
    coverSeq: 'comic-09',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第112话',
    updateDate: '2026-07-02',
    description: '辞去高压工作后，我在海边小镇开了一家小小的咖啡馆。每天接待各色各样的客人，听他们讲述生活中的喜怒哀乐。这里有失意的画家、迷路的旅人、还有那个总点同一杯拿铁的沉默男子。治愈别人的同时，我也在治愈自己。',
    tags: ['治愈', '美食', '日常', '文艺'],
    chapters: 112,
    totalViews: 2070000,
    isHot: false,
  },
  {
    id: 'magic-chef',
    title: '魔法厨神',
    author: '金南俊',
    slug: 'magic-chef',
    category: 'fantasy',
    rating: 9.2,
    coverSeq: 'comic-10',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第143话',
    updateDate: '2026-07-03',
    description: '在异世界开设餐厅的料理漫画！前世是米其林三星主厨，转生后发现自己来到了一个美食荒漠般的魔法世界。用现代料理征服异世界居民的味蕾，顺便拯救世界？一部让你边看边流口水的奇幻美食漫画。',
    tags: ['异世界', '美食', '搞笑', '冒险'],
    chapters: 143,
    totalViews: 2890000,
    isHot: false,
  },
  {
    id: 'boss-secretary',
    title: '总裁的专属秘书',
    author: '金多美',
    slug: 'boss-secretary',
    category: 'love',
    rating: 9.0,
    coverSeq: 'comic-11',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第67话',
    updateDate: '2026-07-01',
    description: '成为业界最年轻CEO的专属秘书后，我才发现他私下里和公开场合完全判若两人。白天是冷面霸总，晚上却……等等，为什么我要帮他照顾他捡来的流浪猫？！一段办公室里的反差萌恋爱物语。',
    tags: ['办公室', '反差萌', '甜宠', '都市'],
    chapters: 67,
    totalViews: 1560000,
    isHot: false,
  },
  {
    id: 'shadow-assassin',
    title: '暗影刺客',
    author: '李政宰',
    slug: 'shadow-assassin',
    category: 'action',
    rating: 9.4,
    coverSeq: 'comic-12',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第189话',
    updateDate: '2026-07-02',
    description: '从小被秘密组织培养为顶尖刺客的少年，在一次任务中发现了组织的黑暗真相。背叛组织后，他成为了被全世界追杀的目标。在逃亡路上，他逐渐发现自己的身世与一个足以颠覆世界的秘密紧密相连。',
    tags: ['刺客', '动作', '悬疑', '复仇'],
    chapters: 189,
    totalViews: 4130000,
    isHot: true,
  },
  {
    id: 'cat-diary',
    title: '猫咪日记',
    author: '金裕贞',
    slug: 'cat-diary',
    category: 'daily',
    rating: 9.1,
    coverSeq: 'comic-13',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第156话',
    updateDate: '2026-07-03',
    description: '从猫咪视角讲述的暖心故事。被遗弃的小橘猫"年糕"被一位独居老人收养后，开始了一段温暖治愈的生活。老人的孤独、猫咪的调皮、以及渐渐产生的羁绊，每一页都让人心头一暖。',
    tags: ['动物', '治愈', '日常', '温情'],
    chapters: 156,
    totalViews: 1780000,
    isHot: false,
  },
  {
    id: 'time-loop',
    title: '时间循环',
    author: '朴叙俊',
    slug: 'time-loop',
    category: 'suspense',
    rating: 9.5,
    coverSeq: 'comic-14',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第98话',
    updateDate: '2026-07-01',
    description: '每天早上醒来，我都会回到同一天——2026年4月15日。在这个无限循环中，我发现了这座城市的诸多秘密：失踪的市长、被掩盖的真相、以及那栋永远无法进入的灰色大楼。打破循环的钥匙，就藏在其中。',
    tags: ['循环', '推理', '悬疑', '都市'],
    chapters: 98,
    totalViews: 3410000,
    isHot: true,
  },
  {
    id: 'noble-lady',
    title: '贵族千金',
    author: '金惠允',
    slug: 'noble-lady',
    category: 'drama',
    rating: 9.3,
    coverSeq: 'comic-15',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第134话',
    updateDate: '2026-07-02',
    description: '父亲突然去世后，作为家中长女的我必须撑起整个家族。在充满阴谋与背叛的贵族社会中，一个十八岁的少女如何守护家族荣誉？这是一部关于成长、责任与女性力量的古装剧情漫画。',
    tags: ['古装', '成长', '家族', '女性力量'],
    chapters: 134,
    totalViews: 2670000,
    isHot: false,
  },
  {
    id: 'high-school-monster',
    title: '高校怪物',
    author: '崔宇植',
    slug: 'high-school-monster',
    category: 'comedy',
    rating: 8.9,
    coverSeq: 'comic-16',
    coverWidth: 400,
    coverHeight: 560,
    status: '连载中',
    updatedChapter: '第88话',
    updateDate: '2026-06-29',
    description: '转学生看起来像普通高中生，但他其实是……来自怪物世界的交换生！在人类高中里努力不暴露身份的日常大作战。从课堂上的小意外到运动会的大混乱，笑料永远不重样！',
    tags: ['校园', '搞笑', '奇幻', '轻松'],
    chapters: 88,
    totalViews: 1320000,
    isHot: false,
  },
] as const;

export const hotComics = comics.filter(c => c.isHot);
export const latestComics = [...comics].sort((a, b) => b.updateDate.localeCompare(a.updateDate));
export const completedComics = comics.filter(c => c.status === '完结');